import handlersStack from './HandlersStack'
import { EVENTS } from './constants'

const _addEventHandler = function(event) {
  document.addEventListener(event, (e) => {
    const nextHandler = handlersStack.getHandlersIterator(event)
    let next = nextHandler()
    while (next !== null) {
      let handled = next(e.keyCode, e)
      if (handled === true) {
        break
      }
      next = nextHandler()
    }
  })
}

const initDomHelper = () => {
  _addEventHandler(EVENTS.KEY_PRESS)
  _addEventHandler(EVENTS.KEY_UP)
  _addEventHandler(EVENTS.KEY_DOWN)
}

const initialized = false
export default () => {
  if (!initialized) {
    initDomHelper()
  }
}



// WEBPACK FOOTER //
// ./web/js/keyHandlers/domHelper.js